import dayjs from "dayjs";
import { getLangFromLocal } from "./lang.util";
import { LANG_OBJ } from "../constant/index";

// 判断是否为中日韩语言
const isCJKLang = (lang) => [
  LANG_OBJ.zh_CN,
].includes(lang);

const getDateOrder = (lang) => {
  switch (lang) {
    case LANG_OBJ.zh_CN:
    case LANG_OBJ.zh_HK:
    case LANG_OBJ.ja_JP:
    case LANG_OBJ.ko_KR:
      return ['YYYY', 'MM', 'DD'];
    case LANG_OBJ.en_US:
      return ['MM', 'DD', 'YYYY'];
    default:
      return ['DD', 'MM', 'YYYY'];
  }
};

export const getDateFormatByLang = ({
  formatType = 'yearmonthday',
  separation = '-'
} = {}) => {
  const lang = getLangFromLocal();

  // 动态选择分隔符：中日韩用传入参数，其他语言强制用斜杠
  const dateSeparator = isCJKLang(lang) ? separation : '/';
  const datePart = getDateOrder(lang).join(dateSeparator);

  const FormatMap = {
    yearmonthday: datePart,
    yearmonthdayhourminute: `${datePart} HH:mm`,
    yearmonthdayhourminutesecond: `${datePart} HH:mm:ss`,
    hourminute: 'HH:mm'
  };

  return FormatMap[formatType] || datePart;
};

export const getDateStrByLocal = ({
  date = new Date(),
  formatType = 'yearmonthdayhourminute',
  separation = '-'
} = {}) => {
  const d = dayjs(date);
  return d.isValid() ? d.format(getDateFormatByLang({ formatType, separation })) : '';
}
